<template>
  <div class="check-work-body">

    <div style="display: flex;flex-direction: row">
      <div style="width: 200px">
        <area-tree @nodeClick="nodeClick1"></area-tree>
      </div>
      <div>
        <div class="search-wrap">
          <el-button size="mini" v-if="ERP.isPermission(26005001004001)" type="primary" @click="editArticle()" style="margin-right: 5px;" icon="el-icon-plus">添加
          </el-button>
          <el-input size="mini" placeholder="请输入搜关键字" v-model="keyword" clearable style="width: 200px"></el-input>
          <el-button size="mini" type="primary" @click="search">搜索</el-button>

          <div style="width: 30px;display: inline-block;"></div>
          <el-button size="mini" type="primary" v-if="ERP.isPermission(26005001004005)" @click="exportExcel">导出</el-button>
          <el-button size="mini" type="primary" v-if="ERP.isPermission(26005001004004)" @click="importExcel">导入</el-button>
        </div>

        <div class="table-wrap">
          <el-table v-if="pageData" v-loading="loading" :data="pageData.list" height="70vh">
<!--            <el-table-column prop="id" label="id" align="center"></el-table-column>-->
            <el-table-column prop="number" label="合同编号" align="center" min-width="180" fixed></el-table-column>
            <el-table-column prop="name" label="合同名称" align="center" min-width="180" fixed></el-table-column>
            <el-table-column prop="contract_type" label="合同类型" align="center" width="180">
              <template slot-scope="scope">
                <span v-if="scope.row.contract_type==1">战略合同</span>
                <span v-if="scope.row.contract_type==2">预合同（合同信息备案表）</span>
              </template>
            </el-table-column>
            <el-table-column prop="entry_type_name" label="业务类型" align="center"></el-table-column>
            <el-table-column prop="party_a" label="甲方" align="center" width="180"></el-table-column>
            <el-table-column prop="party_b" label="乙方" align="center" width="180"></el-table-column>
            <el-table-column prop="project_name" label="项目名称" align="center" min-width="180"></el-table-column>
            <el-table-column prop="contract_price" label="合同总价" align="center"></el-table-column>
            <el-table-column prop="payment_cycle" label="款项周期" align="center"></el-table-column>
            <el-table-column prop="performance_bond" label="履约保证金" align="center"></el-table-column>
            <el-table-column prop="contract_personnel_number" label="合同人数" align="center"></el-table-column>
            <el-table-column prop="service_area" label="服务面积" align="center"></el-table-column>
            <el-table-column prop="payment_method" label="回款周期" align="center"></el-table-column>
            <el-table-column prop="signing_time" label="签订时间" align="center" width="180"></el-table-column>
            <el-table-column prop="mobilization_time" label="进场时间" align="center" width="180"></el-table-column>
            <el-table-column prop="mobilization_time" label="合同起始" align="center" width="180">
              <template slot-scope="scope">
                {{ (scope.row.charging_start_end || []).join("-") }}
              </template>
            </el-table-column>
            <el-table-column prop="mobilization_time" label="是否已撤场" align="center">
              <template slot-scope="scope">
                <el-tag size="mini" :type="!scope.row.is_stop?'success':'danger'">{{scope.row.is_stop?'是':'否'}}</el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="create_time" label="创建时间" align="center" width="180"></el-table-column>
            <el-table-column prop="update_time" label="修改时间" align="center" width="180"></el-table-column>
            <el-table-column label="操作" align="center" width="380">
              <template slot-scope="scope">
                <el-button type="warning" size="mini" v-if="ERP.isPermission(26005001004003) && scope.row.is_stop == 0" icon="el-icon-news" @click="openRenewDialog(scope.row)">续签</el-button>
                <el-button type="primary" size="mini" v-if="ERP.isPermission(26005001004002) && scope.row.is_stop == 0" icon="el-icon-edit" @click="editArticle(scope.row)">修改</el-button>
				        <el-button size="mini" v-if="ERP.isPermission(26005001004003) && scope.row.is_stop == 0" icon="el-icon-news" @click="openShutDownDialog(scope.row)">撤场</el-button>
                <el-button size="mini" v-if="scope.row.is_stop == 1" icon="el-icon-edit" @click="editArticle(scope.row)">查看</el-button>
				        <el-button type="danger" size="mini" v-if="ERP.isPermission(26005001004011)" icon="el-icon-delete" @click="deletes(scope.row)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <div class="pagination-wrap">
          <el-pagination background layout="prev, pager, next" :total="pageData.total*1" :page-size="pageData.pageSize*1"
                         :current-page="pageData.page*1" @current-change="pageChange"></el-pagination>
        </div>
      </div>
    </div>

    <!-- 修改窗口 -->
    <el-dialog title="合同编辑" :visible.sync="dialogVisible" width="1000px" :close-on-click-modal="false">

      <div style="max-height: 600px;overflow-y: auto;">
        <el-form :model="form" ref="form" :rules="rules" label-width="100px" size="mini" style="margin-right: 50px;">

          <el-row :gutter="10">
            <el-col :span="12">
              <el-form-item label="合同类型" prop="contract_type">
                <el-select v-model="form.contract_type" placeholder="合同类型">
                  <el-option
                    v-for="item in [{id:1,name:'战略合同'},{id:2,name:'预合同（合同信息备案表）'}]"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="业务类型" prop="entry_type">
                <el-select v-model="form.entry_type" placeholder="业务类型" @change="onSelectBusiness">
                  <el-option
                    v-for="item in business_list"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="组织架构" prop="contract_area_ids">
                <SelectContractArea :area_ids="form.contract_area_ids" @onAreaChange="onContractAreaChange" :pid="0" />
              </el-form-item>
              <el-form-item label="合同项目" prop="project_id">
                <SelectProject v-model="form.project_id" :contract_area_id="form.contract_area_ids" />
              </el-form-item>
              <el-form-item label="合同名称" prop="name">
                <el-input class="form-input" v-model="form.name" autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item label="合同编号" prop="number_str">
                <el-col :span="6">
                  <el-input class="form-input" v-model="form.number_code" autocomplete="off" style="width: 100%;"></el-input>
                </el-col>
                <el-col :span="9">
                  <el-input class="form-input" v-model="form.number_str" autocomplete="off" style="width: 100%;"></el-input>
                </el-col>
                <el-col :span="6">
                  <el-input class="form-input" v-model="form.number_ext" autocomplete="off" style="width: 100%;" ></el-input>
<!--                  <el-input-number v-model="form.number_ext" :precision="2" :min="0"  :controls="false" style="width: 100%;"></el-input-number>-->
                </el-col>
              </el-form-item>
              <el-form-item label="签订时间" prop="signing_time" :rules="form.contract_type === 1?rules.target:[{ required: false}]">
                <el-date-picker
                  v-model="form.signing_time"
                  type="date"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  placeholder="选择日期">
                </el-date-picker>
              </el-form-item>
              <el-form-item label="进场时间" prop="mobilization_time" :rules="form.contract_type === 1?rules.target:[{ required: false}]">
                <el-date-picker
                  v-model="form.mobilization_time"
                  type="date"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  placeholder="选择日期">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="所在板块" prop="contract_business">
                <el-select class="form-input" v-model="form.contract_business">
                  <el-option label="物业板块" value="物业板块"></el-option>
                  <el-option label="城服板块" value="城服板块"></el-option>
                  <el-option label="保洁板块" value="保洁板块"></el-option>
                  <el-option label="工程板块" value="工程板块"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="合同总价" prop="contract_price">
                <el-input class="form-input" :disabled="!ERP.isPermission(26005001004006)" v-model="form.contract_price" autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item label="履约保证金" prop="performance_bond">
                <el-input class="form-input" v-model="form.performance_bond" autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item label="合同人数" prop="title">
                <el-input class="form-input" v-model="form.contract_personnel_number" autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item label="服务面积" prop="service_area">
                <el-input class="form-input" v-model="form.service_area" autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item label="付款周期" prop="payment_method">
                <el-select v-model="form.payment_method" placeholder="付款周期">
                  <el-option
                    v-for="item in [{id:1,name:'月结'},{id:2,name:'季结'}]"
                    :key="item.id"
                    :label="item.name"
                    :value="item.name">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="合同负责人" prop="contract_leader">
                <el-input class="form-input" v-model="form.contract_leader" autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item label="撤场时间" prop="demobilization_time">
                <el-date-picker
                  v-model="form.demobilization_time"
                  type="date"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  placeholder="选择日期">
                </el-date-picker>
              </el-form-item>
              <el-form-item label="到期情况" prop="end_detail">
                <el-input class="form-input" v-model="form.end_detail"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-divider></el-divider>
          <el-row :gutter="10">
            <el-col :span="12">
              <el-form-item label="甲方" prop="party_a" :rules="form.contract_type === 1?rules.target:[{ required: false}]">
                <SearchPartnership :value="form.party_a" @onValue="form.party_a=$event;" @onChang="form.party_a=$event.name;form.party_a_abbreviation=$event.abbreviation;" />
              </el-form-item>
              <el-form-item label="甲方简称" prop="party_a" :rules="form.contract_type === 1?rules.target:[{ required: false}]">
                <el-input class="form-input" v-model="form.party_a_abbreviation" autocomplete="off" placeholder="简称"></el-input>
              </el-form-item>
              <el-form-item label="甲方联系人" prop="party_a_people" >
                <el-input class="form-input" v-model="form.party_a_people" autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item label="甲方联系方式" prop="party_a_tell" >
                <el-input class="form-input" v-model="form.party_a_tell" autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item label="甲方联系地址" prop="party_a_address">
                <el-input class="form-input" v-model="form.party_a_address" autocomplete="off"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="乙方" prop="party_b" :rules="form.contract_type === 1?rules.target:[{ required: false}]">
                <SearchPartnership :value="form.party_b" @onValue="form.party_b=$event;" @onChang="form.party_b=$event.name;form.party_b_abbreviation=$event.abbreviation;" />
              </el-form-item>
              <el-form-item label="乙方简称" prop="party_b" :rules="form.contract_type === 1?rules.target:[{ required: false}]">
                <el-input class="form-input" v-model="form.party_b_abbreviation" autocomplete="off" placeholder="简称"></el-input>
              </el-form-item>
              <el-form-item label="乙方联系人" prop="party_b_people">
                <el-input class="form-input" v-model="form.party_b_people" autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item label="乙方联系方式" prop="party_b_tell">
                <el-input class="form-input" v-model="form.party_b_tell" autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item label="乙方联系地址" prop="party_b_address">
                <el-input class="form-input" v-model="form.party_b_address" autocomplete="off"></el-input>
              </el-form-item>

            </el-col>
          </el-row>
          <el-divider></el-divider>
          <el-form-item label="合同起始" prop="charging_start_end">
            <el-date-picker
              :disabled="!ERP.isPermission(26005001004007)"
              v-model="form.charging_start_end"
              type="daterange"
              unlink-panels
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd">
            </el-date-picker>
            <span style="margin-left: 10px;">{{month_money_list.length}} 个月</span>
          </el-form-item>
          <el-form-item label="款项周期" prop="payment_cycle">
            <el-input class="form-input" :disabled="!ERP.isPermission(26005001004008)" v-model="form.payment_cycle" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="月金额" prop="title">
            <el-table
              :data="month_money_list"
              height="250"
              border
              style="width: 100%">
              <el-table-column
                prop="month"
                label="月份">
              </el-table-column>
              <el-table-column
                prop="money"
                label="金额">
                <template slot-scope="scope">
                  <el-input :disabled="is_able_month_money_keys['_'+scope.row.key]&&!ERP.isPermission(26005001004009)" v-model="scope.row.money"></el-input>
                </template>
              </el-table-column>
              <el-table-column
                prop="address"
                label="操作">
              </el-table-column>
            </el-table>
            <div :style="{color: (form.contract_price==all_account?'#1cb004':'#ff3d00')}">合同总价：{{form.contract_price}} &nbsp;&nbsp;&nbsp; 月合计金额：{{all_account}} &nbsp;&nbsp;&nbsp; 浮动：{{Math.round((form.contract_price-all_account) * 100) / 100}}</div>
          </el-form-item>
          <el-form-item label="附件" prop="title">
            <upload-files-sysc :host-url="host_url" :upload-url="host_url+'/contract/contract/uploadFile'"  :limit="20" v-model="form.contract_files"></upload-files-sysc>
          </el-form-item>
          <el-form-item label="备注" prop="title">
            <el-input
              type="textarea"
              placeholder="请输入内容"
              v-model="form.remarks"
              maxlength="100"
              show-word-limit
            >
            </el-input>
          </el-form-item>

          <el-form-item label="是否续签" prop="title">
            <el-switch
              v-model="form.is_renewal"
              active-color="#13ce66"
              inactive-color="#ff4949">
            </el-switch>
          </el-form-item>
          <el-form-item label="是否过期" prop="title">
            {{ form.is_end?'是':'否'  }}
          </el-form-item>
        </el-form>
      </div>

      <div slot="footer" class="dialog-footer" v-if="form.is_stop == 0">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button :type="all_account!=form.contract_price?'danger':'primary'" :disabled="all_account!=form.contract_price" @click="submitForm('form')">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 续签合同弹窗 -->
    <el-dialog
      title="合同续签"
      :visible.sync="renewDialogVisible"
      width="650px"
      @close="handleRenewClose">
      <el-form
        :model="renewForm"
        ref="renewForm"
        label-width="120px">
        <el-form-item label="合同结束日期" prop="originalEndDate">
          {{renewForm.originalEndDate}}
          </el-form-item>

        <el-form-item label="续签日期" prop="renewDate">
          <el-date-picker
            v-model="renewForm.renewDate"
            type="date"
            placeholder="选择续签日期"
            value-format="yyyy-MM-dd"
            :picker-options="{
              disabledDate: (time) => {
                return new Date(renewForm.originalEndDate) > new Date(time);
              }
            }">
          </el-date-picker>
        </el-form-item>

        <el-form-item label="续签合同每月金额(元)" prop="totalAmount">
          <el-input-number @change="handleRenewAmountChange"
            v-model="renewForm.totalAmount"
            :min="0" style="width: 100%"
            :precision="2"
            placeholder="请输入每月合同金额"/>
        </el-form-item>

        <el-form-item label="每月金额(元)" prop="monthlyAmount">
           <el-table
            :data="renewForm.monthlyList"
            border
            style="width: 100%"
            height="200px">
            <el-table-column
              prop="month"
              label="月份"
              width="180">
            </el-table-column>
            <el-table-column
              prop="amount"
              label="金额">
              <template slot-scope="scope">
                <el-input-number
                  v-model="scope.row.amount"
                  :min="0"
                  :precision="2"
                  controls-position="right"
                  style="width: 100%"/>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
        </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="renewDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleRenewSubmit">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 撤场窗口 -->
    <el-dialog title="合同撤场" :visible.sync="shutDownDialogVisible" width="650px" @close="shutDownDialogVisible = false">
      <el-form>
        <el-form-item label="撤场日期">
          <el-date-picker v-model="shutDownForm.endDate"
                          type="date"
                          placeholder="选择撤场日期"
                          value-format="yyyy-MM-dd"
                          :picker-options="{
              disabledDate: (time) => {
                return new Date(shutDownForm.originalEndDate) < new Date(time) || new Date(time) < new Date();
              }
            }"></el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="shutDownDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleShutDownSend">确 定</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>

import {Loading} from 'element-ui';
import CommonHelp from "./common/CommonHelp";
import UploadFilesSysc from "./components/UploadFilesSysc";
import AreaTree from "./components/AreaTree";
import SelectContractArea from "./components/SelectContractArea";
import SelectProject from "./components/SelectProject";
import SearchPartnership from "./components/SearchPartnership";
import {Message} from "element-ui";
import Confirm from "iview/src/components/modal/confirm";

export default {
  name: "Contract",
  components: {SearchPartnership, SelectProject, SelectContractArea, AreaTree, UploadFilesSysc},
  data() {
    return {
      host_url:"",
      keyword: '',
      loading: false,
      contract_area_id:'',
      pageData: {
        list: [],
        total: 0,
        pageSize: 20,
        page: 1
      },
      dialogVisible: false,
      rules: {
        name: [
          { required: true, message: '请填合同名称', trigger: 'blur' },
        ],
        project_id: [
          { required: true, message: '请选择项目', trigger: 'change' },
        ],
        number_str: [
          { required: true, message: '请填写合同编号', trigger: 'blur' },
        ],
        entry_type: [
          { required: true, message: '请选择业务类型', trigger: 'change' },
        ],
        signing_time: [
          { required: true, message: '请选择签订时间', trigger: 'change' },
        ],
        mobilization_time: [
          { required: true, message: '请选择进场时间', trigger: 'change' },
        ],
        contract_price: [
          { required: true, message: '请填写合同总价', trigger: 'blur' },
        ],
        party_a: [
          { required: true, message: '请填写甲方', trigger: 'blur' },
        ],
        party_b: [
          { required: true, message: '请填写乙方', trigger: 'blur' },
        ],
        charging_start_end: [
          { required: true, message: '请选择合同起始时间', trigger: 'change' },
        ],
        payment_cycle: [
          { required: true, message: '请填写款项周期', trigger: 'blur' },
        ],
      },
      form: {
        name: "",
        contract_area_ids:"",
        contract_area:"",
        contract_business: "",
        project_id:"",
        number: "",
        number_code:"",
        number_str:'',
        number_ext:"",
        party_a: "",
        party_a_abbreviation: "",
        party_a_people: "",
        party_a_tell: "",
        party_a_address: "",
        party_b: "",
        party_b_abbreviation: "",
        party_b_people: "",
        party_b_tell: "",
        party_b_address: "",
        entry_type: "",
        entry_type_name:"",
        performance_bond: "",
        contract_price: 0,
        contract_personnel_number: "",
        service_area: "",
        payment_method: "",
        contract_leader: "",
        signing_time: "",
        mobilization_time: "",
        payment_cycle:12,
        charging_start_end: "",
        charging_start_time: "",
        charging_end_time: "",
        month_money_list:"",
        contract_files: "",
        remarks: "",
        is_renewal:false,
        is_end:false,
        is_stop:false,
        renewal_id:0,
        demobilization_time:'',
        end_detail :'',
        contract_type:'1',
      },
      uploadUrl: "",
      month_money_list: [],
      month_money_old_list:[],
      project_list: [],
      business_list:[],
      contract_type_list:[{id:1,name:'战略合同'},{id:2,name:'预合同（合同信息备案表）'}],

      // 续签
      renewDialogVisible : false,
      renewForm : {
        id : 0,
        originalEndDate : '',
        renewDate : '',
        totalAmount : '',
        monthlyList: []  // 修改数据结构为数组
      },

      // 撤场
      shutDownDialogVisible : false,
      shutDownForm : {
        id : 0 ,
        endDate : '',
        originalEndDate : '',
      },
    }
  },
  created() {
    this.host_url=CommonHelp.getBaseURL();
    this.getBusinessList();
  },
  activated() {
    this.getList()
  },
  watch: {
    dialogVisible(val) {
      if (val == false) {
        // this.fileList = []
      }
    },
    "form.charging_start_end": function (n) {
      if(n){
        this.form.charging_start_time = n[0];
        this.form.charging_end_time = n[1];
        this.componentMonth()
      }else {
        this.month_money_list = []
      }
    },
    "form.contract_price": function (n) {
      // this.componentMonth()
    },
    "form.payment_cycle": function (n) {
      this.componentMonth()
    },
    "form.number_code":function (n) {
      // this.initNumber()
    },
    "form.number_str":function (n) {
      // this.initNumber()
    },
    numberStr(n){
      this.form.number=n;
    },
    "form.month_money_list":{
      handler(n){
        this.month_money_list=n||[];
      },
      deep:true,
      immediate:true
    },
    "form.entry_type": function (n) {
      if(n){
        let entry_type=this.business_list.find(ret=>{ return ret.id===n });
        if(entry_type){
          this.form.entry_type_name=entry_type.name;
        }
      }else {
        this.form.entry_type_name=""
      }
    },
    month_money_list:{
      handler(n){
        this.form.month_money_list=n||[];
      },
      deep:true,
      immediate:true
    },
    all_account(n){
      console.log(n)
    },
    "form.signing_time":function (n) {
      var that=this;
      n&&that.getMaxNumber(n,ret=>{
        that.form.number_str=ret;
      })
    },
    "renewForm.renewDate" : function(newDate){
      if(newDate && this.renewForm.originalEndDate) {
        if(parseFloat(this.renewForm.totalAmount) > 0){
          // 后一天
          let nextDay = new Date(new Date(this.renewForm.originalEndDate).getTime() + 24 * 60 * 60 * 1000);
          this.renewForm.monthlyList = this.monthContractPriceMath(nextDay , newDate , this.renewForm.totalAmount)
        }else{
          this.renewForm.monthlyList = this.generateMonthList(
            this.renewForm.originalEndDate,
            newDate
          );
    }
      }
    }
  },
  computed:{
    numberStr(){
      return this.form.number_code+this.form.number_str+(this.form.number_ext?("-"+this.form.number_ext):'');
    },
    all_account(){
      return this.month_money_list.reduce(function(total, currentValue, currentIndex){
        total+=(currentValue.money*1);
        return Math.round(total*100)/100;
      }, 0)
    },
    month_keys(){
      return this.month_money_list.map(ret=>{
        return ret.key;
      })
    },
    is_able_month_money_keys(){
      let t={}
      this.month_money_old_list.map(ret=>{
        t['_'+ret.month_key]=ret.status!==1
      })
      return t;
    }
  },
  methods: {
    getFormData(data) {
      return Object.assign({
        id: '',
        name: "",
        contract_area_ids:"",
        contract_area:"",
        project_id:"",
        number: "",
        number_code:"",
        number_str:'',
        number_ext:"",
        party_a: "",
        party_a_abbreviation: "",
        party_a_people: "",
        party_a_tell: "",
        party_a_address: "",
        party_b: "",
        party_b_abbreviation: "",
        party_b_people: "",
        party_b_tell: "",
        party_b_address: "",
        entry_type: "",
        entry_type_name:"",
        performance_bond: "",
        contract_price: 0,
        contract_personnel_number: "",
        service_area: "",
        payment_method: "",
        contract_leader: "",
        signing_time: "",
        mobilization_time: "",
        payment_cycle:12,
        charging_start_end: "",
        charging_start_time: "",
        charging_end_time: "",
        month_money_list:"",
        contract_files: "",
        remarks: "",
        is_renewal:false,
        is_end:false,
        is_stop:false,
        renewal_id:0,
        demobilization_time:'',
        contract_type: ""
      }, data)
    },
    search() {
      this.pageData.page = 1
      this.getList()
    },
    getList() {
      var that = this;
      that.loading = true;
      let where={};
      this.keyword&&(where.name=this.keyword);
      this.contract_area_id&&(where.contract_area_ids=this.contract_area_id);
      CommonHelp.get("Contract/getList",{
        where:JSON.stringify(where),
        page: this.pageData.page,
        page_size: this.pageData.pageSize
      },res=>{
        if(res.code) {
          res.data.list.map(ret=>{
            try {
              ret.month_money_list=JSON.parse(ret.month_money_list)
            }catch (e) {
              ret.month_money_list=[]
            }
            ret.charging_start_end&&(ret.charging_start_end=JSON.parse(ret.charging_start_end))
            ret.is_renewal=ret.is_renewal !== 0;
            ret.is_end=ret.is_end !== 0
            ret.is_stop=ret.is_stop !== 0
            return ret;
          })
          that.pageData=res.data
        }
        that.loading=false;
      })
    },
    getBusinessList(){
      var that=this;
      CommonHelp.get("Business/getList",{
        page: 1,
        page_size: 100
      },res=>{
        if(res.code) {
          that.business_list=res.data.list
        }
      })
    },
    pageChange(i) {
      this.pageData.page = i
      this.getList()
    },
    editArticle(item) {
      var that=this;
      this.getBusinessList();
      if (!item) {
        this.form = this.getFormData({})
        that.getMaxNumber("",ret=>{
          that.form.number_str=ret;
        })
        this.form.contract_type = 1
      } else {
        this.form = item
      }
      this.dialogVisible = true
      // setTimeout(function () {
      //   that.getMonthKeys();
      // },200)
    },
    editArticleExt(item) {
      this.getBusinessList();
      if (!item) {
        this.form = this.getFormData({})
      } else {
        let p_item=JSON.parse(JSON.stringify(item));
        p_item.renewal_id=p_item.id;
        p_item.is_renewal=true;
        p_item.month_money_list="";
        p_item.charging_start_end="";
        p_item.charging_start_time="";
        p_item.charging_end_time="";
        p_item.signing_time="";
        p_item.demobilization_time="";
        p_item.remarks="";
        p_item.number="";
        this.getMaxNumber("",ret=>{
          p_item.number_str=ret;
        })
        p_item.number_ext="";

        p_item.id=undefined;
        this.form = p_item
      }
      this.dialogVisible = true
    },

    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.formLoading = true
          let data = Object.assign({}, this.form)
          data.charging_start_end=JSON.stringify(data.charging_start_end)
          data.month_money_list=JSON.stringify(data.month_money_list)
          console.log(data)
          data.is_renewal=data.is_renewal?1:0;
          data.is_end=data.is_end?1:0;
          data.is_stop=data.is_stop?1:0;
          console.log(data)
          CommonHelp.post("Contract/save",data,res => {
            this.$message({type: res.code === 1 ? 'success': 'error', message: res.msg})
            if(res.code) {
              this.dialogVisible = false
              this.getList()
            }
            this.formLoading = false
          })
        } else {
          return false;
        }
      });
    },

    setFrom(data) {
      var that = this;
      data.month_money_list=JSON.stringify(data.month_money_list)
      data.charging_start_end=JSON.stringify(data.charging_start_end)
      data.is_renewal=data.is_renewal?1:0;
      data.is_end=data.is_end?1:0;
      data.is_stop=data.is_stop?1:0;
      CommonHelp.post("Contract/save",data,res => {
        that.$message({type: res.code === 1 ? 'success': 'error', message: res.msg})
        if(res.code) {
          that.getList()
        }
      })
    },

    componentMonth() {
      var that = this;
      let list = CommonHelp.getMonths(that.form.charging_start_time, that.form.charging_end_time);
      if (that.form.charging_start_end) {
        if(!that.form.payment_cycle){
          return false;
        }
        let m_list = JSON.parse(JSON.stringify(that.month_money_list))
        that.month_money_list = [];
        let month_money = Math.round(that.form.contract_price / that.form.payment_cycle * 100) / 100
        let money2=that.form.contract_price;
        let all_money=0;
        list.map((ret, index) => {
          let self_month_money=0;
          if(money2>=month_money){
            money2=Math.round((money2-month_money)*100)/100;
            self_month_money=month_money;
          }else if(money2>0){
            self_month_money=money2;
            money2=0;
          }else {
            self_month_money=0;
          }
          let key=(m_list[index]&&m_list[index].key)?m_list[index].key:(new Date()).getTime()+''+Math.round(Math.random()*100000);
          that.month_money_list.push({
            ...m_list[index],
            month: ret,
            money: that.is_able_month_money_keys['_'+key]? self_month_money:((m_list[index]||{}).money===undefined?self_month_money:(m_list[index]||{}).money),
            key:key
          })
          all_money+=self_month_money
        })
      } else {
        that.month_money_list = []
      }
      that.$forceUpdate()
    },

    setMoney(item, index) {
      var that = this;
      let all_use_money=that.month_money_list.reduce(function(total, currentValue, currentIndex){
        if(currentIndex!==0&&currentIndex!==(that.month_money_list.length-1)){
          total+=currentValue.money;
        }else {
          total+=0;
        }
        return total;
      }, 0)
      let month_money = (that.form.contract_price-all_use_money);
      if (index) {
        that.month_money_list[0].money = Math.round((month_money - item.money) * 100) / 100
      } else {
        that.month_money_list[that.month_money_list.length - 1].money = Math.round((month_money - item.money) * 100) / 100
      }

    },
    onSelectBusiness(id){
      var that=this;
      let business=that.business_list.find(ret=>{ return ret.id===id })
      that.form.number_code=business.code;
    },
    nodeClick1(n){
      this.contract_area_id=n.id;
      this.pageData={
        list:[],
        total:0,
        pageSize:20,
        page:1
      }
      this.getList()
    },
    onContractAreaChange({data,pathData,ids}){
      let adrr=""
      pathData.map((ret,index)=>{
        adrr+=ret.name+(pathData[index+1]?' -> ':'')
      })
      this.form.contract_area=adrr;
      this.form.contract_area_ids=ids.join(',')
    },
    deletes(item){
      this.$confirm(`此操作将删除 [ ${item.name} ] 合同，是否继续?`, '提示', {type: 'warning'}).then(() => {
        var that=this;
        CommonHelp.post("Contract/goDelete", {id:item.id},res => {
          that.$message({type: res.code === 1 ? 'success': 'error', message: res.msg})
          if(res.code) {
            that.getList()
          }
        })
      })

    },
    exportExcel(){
      var that=this;
      let where={};
      this.keyword&&(where.name=this.keyword);
      this.contract_area_id&&(where.contract_area_ids=this.contract_area_id);
      CommonHelp.get("Contract/exportExcel",{
        where:JSON.stringify(where),
        page: this.pageData.page,
        page_size: this.pageData.pageSize
      },res=>{
        if(res.code) {
          window.open(that.host_url + res.data)
        }
      })
    },
    importExcel(){
      var that=this;
      CommonHelp.uploadFile(ret=>{
        // console.log(ret);
        CommonHelp.post("Contract/importExcel",{ file_name:ret },res=>{
          if(res.code) {
            that.getList();
            if(res.data&&res.data.length){
              that.error_show_status=true;
              that.error_list=res.data;
            }
          }else {
            this.$message(res.msg);
          }
        })
      });
    },
    getMonthKeys(){
      var that=this;
      CommonHelp.post("Finance/getMonthkeys",{ keys:this.month_keys.join(',') },res=>{
        if(res.code) {
          that.month_money_old_list=res.data;
        }
      })
    },
    getMaxNumber(ymd="",callback){
      var that=this;
      CommonHelp.post("Contract/getMaxNumber",{ymd:ymd},res=>{
        if(res.code) {
          typeof callback==='function'&&callback(res.data);
        }
      })
    },
    // 打开续签弹窗时生成月份表格
    openRenewDialog(row) {
      this.renewForm.id = row.id;
      this.renewForm.originalEndDate = row.charging_start_end[1];
      this.renewForm.renewDate = '';
      this.renewForm.monthlyList = [];
      this.renewDialogVisible = true;
    },
    // 生成月份列表方法
    generateMonthList(startDate, endDate) {
      const start = new Date(startDate);
      const end = new Date(endDate);
      const monthList = [];

      while (start <= end) {
        monthList.push({
          month: `${start.getFullYear()}-${(start.getMonth()+1).toString().padStart(2, '0')}`,
          amount: 0
        });
        start.setMonth(start.getMonth() + 1);
    }
      return monthList;
  },
    // 提交续签表单
    handleRenewSubmit() {
      var that = this;
      this.$refs.renewForm.validate(valid => {
        if (valid) {
          CommonHelp.post("Contract/renewal",{
            id : this.renewForm.id,
            endDate : this.renewForm.renewDate,
            monthList : this.renewForm.monthlyList,
          },res=>{
            if(res.code) {
              Message.success(res.msg)
              that.getList()
}
          })
          this.renewDialogVisible = false
        }
      })
    },
    // 关闭弹窗时重置表单
    handleRenewClose() {
      this.$refs.renewForm.resetFields()
    },
    // 续签金额变更
    handleRenewAmountChange(){
      let nextDay = new Date(new Date(this.renewForm.originalEndDate).getTime() + 24 * 60 * 60 * 1000);
      this.renewForm.monthlyList = this.monthContractPriceMath(nextDay , this.renewForm.renewDate , this.renewForm.totalAmount);
    },
    // 计算每月合同金额算法
    monthContractPriceMath(startDate , endDate , totalPrice){
      // 所有月份
      let monthList = this.generateMonthList(startDate , endDate);
      console.log('monthList',monthList , startDate , endDate)
      if(monthList.length < 1){
        // 无效日期
        return monthList;
      }
      // 首月
      let firstMonthPrice = totalPrice;
      let firstMonthDays = new Date(startDate);
      let firstYear = firstMonthDays.getFullYear();
      let firstMonth = firstMonthDays.getMonth();
      // 首页的第一天
      let firstDayOfFirstMonth = new Date(firstYear, firstMonth, 1);
      // 首月最后一天
      let lastDayOfFirstMonth = new Date(firstYear, firstMonth + 1, 0);
      let firstAllDaysCount = lastDayOfFirstMonth.getDate();
      if(monthList.length == 1){
        // 只有一个月
        let dayCounts = (new Date(endDate)).getDate() - firstMonthDays.getDate() + 1;
        monthList[0]['amount'] = Math.round(totalPrice * (dayCounts / firstAllDaysCount) * 100 , 2) / 100;
        return monthList;
      }
      let firstMonthDaysCount = lastDayOfFirstMonth.getDate() - firstMonthDays.getDate() + 1 ;
      if(firstAllDaysCount > firstMonthDaysCount){
        // 合同天数不满月
        firstMonthPrice = Math.round(totalPrice * ( firstMonthDaysCount / firstAllDaysCount ) * 100, 2) / 100;
      }

      // 末月
      let lastMonthPrice = totalPrice;
      let lastMonthDays = new Date(endDate);
      let lastYear = lastMonthDays.getFullYear();
      let lastMonth = lastMonthDays.getMonth();
      // 末月的一号
      let lastMonthFirstDay = new Date(lastYear, lastMonth, 1);
      // 末月最后一天
      let lastDayOfLastMonth = new Date(lastYear, lastMonth + 1, 0);
      let lastAllDaysCount = lastDayOfLastMonth.getDate();
      let lastMonthDaysCount = lastMonthDays.getDate() - lastMonthFirstDay.getDate() + 1;
      if(lastMonthDaysCount < lastAllDaysCount){
        lastMonthPrice = Math.ceil(totalPrice * (lastMonthDaysCount / lastAllDaysCount)  * 100, 2) / 100;
      }

      for(let i = 0; i < monthList.length; i++){
        if(i === 0){
          monthList[i].amount = firstMonthPrice;
        }else if(i === monthList.length - 1){
          monthList[i].amount = lastMonthPrice;
        }else{
          monthList[i].amount = totalPrice;
        }
      }
      return monthList;
    },

    // 打开撤场标签
    openShutDownDialog(row){
      this.shutDownForm.id = row.id;
      this.shutDownDialogVisible = true;
      this.shutDownForm.originalEndDate = row.charging_start_end[1];
    },
    handleShutDownSend(){
      var that = this;
      that.$confirm('确认合同撤场吗？').then(() => {
        CommonHelp.post("Contract/shutDown",{
          id : that.shutDownForm.id,
          endDate : that.shutDownForm.endDate,
        },res=>{
          if(res.code) {
            that.$message({type: 'success', message: res.msg});
            that.getList();
            that.shutDownDialogVisible = false;
          }
        })
      })
    }
  },
}
</script>
<style lang="scss" scoped>

@import './common.scss';

.form-input {
  width: 300px;
}
.table-wrap{
  width: calc( 100vw - 120px - 230px );
  overflow-x: scroll;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Contract/Contract.vue